import React, {useEffect, useState} from "react";
import {Image} from "antd";
import {useIntl, connect} from "umi";
import styles from './index.less';

import type {ImContent, ImMessage} from "@/pages/Inquiry/data";
import {request} from "@@/plugin-request/request";
import type {Dispatch, InquiryState} from "@@/plugin-dva/connect";
import {cloneDeep} from "lodash";

export type InquiryMessageProps = {
  imMessage: ImMessage;
  dispatch: Dispatch;
  inquiryHistory: ImMessage[];
};

const InquiryMessage: React.FC<InquiryMessageProps> = ({
                                                         imMessage,
                                                         dispatch,
                                                         inquiryHistory
                                                       }) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.Inquiry.InquiryMessage', intl.formatMessage);

  const [imContent, setImContent] = useState<ImContent>();

  useEffect(() => {
    if (imMessage) {
      try {
        setImContent(JSON.parse(imMessage.content));
      } catch {
      }
    }
  }, []);

  const textRender = (
    <span>
      {imContent?.value}
    </span>
  );

  const imageRender = (
    <Image src={imContent?.value} alt={t('t0', "聊天图片")} style={{maxWidth: '200px'}}/>
  );
  const handleRead = async () => {
    if (imMessage?.audioClick?.hasClicked === false) {
      const res = await request('/hm/online-inquiry/mng/audio-read', {
        method: 'POST',
        data: imMessage.audioClick
      });
      if (res.code === 200) {
        const result = inquiryHistory.map(item => {
          if (item.id === imMessage.id) {
            const newItem = cloneDeep(item);
            newItem.audioClick.hasClicked = true;
            return newItem;

          }
          return item;
        });
        dispatch({
          type: 'inquiry/setInquiryHistory',
          payload: result
        });
      }
    }
  };
  const audioRender = (
    <div className={styles.audioWrap}>
      <audio controls src={imContent?.value} onPlay={handleRead}>
        {t('t1', '您的浏览器不支持音频播放，建议您使用谷歌浏览器')}
      </audio>
      {!imMessage.audioClick?.hasClicked && <div className={styles.audioReadIcon} />}
    </div>
  );

  switch (imContent?.type) {
    case 'text':
      return textRender;
    case 'image':
      return imageRender;
    case 'audio':
      return audioRender;
    default:
      return <span>{t('t2', '未知的消息类别')}</span>;
  }
};

export default connect(({inquiry}: { inquiry: InquiryState }) => ({
    inquiryHistory: inquiry.inquiryHistory
  })
)(InquiryMessage);
